/**
 * filterApi.ts - Filter API Service
 */

import { FilterAPIRequest, FilterAPIResponse } from '@/types/filter.types';
import { isLocalhost } from "core";

const API_BASE_URL =
  typeof window !== "undefined" && isLocalhost()
    ? "http://localhost:3002"
    : "";

export const fetchVectorStoreOptions = async (
    circleId: string
): Promise<string[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/ua/admin/options?type=vector-store&circleId=${circleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`Vector store options API error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        // Extract circle IDs from the options.circles array
        const circleIds: string[] = [];
        if (data.options?.circles && Array.isArray(data.options.circles)) {
            circleIds.push(...data.options.circles.map((circle: any) => circle._id));
        }

        return circleIds;
    } catch (error) {
        console.error('Error fetching vector store options:', error);
        return [];
    }
};

export interface TTSConfig {
    provider: string;
    model: string;
    voice: string;
    language?: string;
    format: string;
}

export const fetchTTSConfig = async (
    circleId: string
): Promise<TTSConfig | null> => {
    try {
        const response = await fetch(`${API_BASE_URL}/ua/admin/options?type=tts-config&circleId=${circleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`TTS config API error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        if (data.ok && data.options) {
            return data.options as TTSConfig;
        }

        return null;
    } catch (error) {
        console.error('Error fetching TTS config:', error);
        return null;
    }
};

export const fetchFilterSuggestions = async (
    request: FilterAPIRequest
): Promise<FilterAPIResponse> => {
    try {
        const response = await fetch(`${API_BASE_URL}/ua/groups/elastic/filter-suggestions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include', // Include cookies for authentication
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`Filter API error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        
        // API returns data nested under 'filters' key
        if (data.filters) {
            return data.filters;
        }
        
        return data;
    } catch (error) {
        console.error('Error fetching filter suggestions:', error);
        throw error;
    }
};

